var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionClear = function SvgActionClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "var(--on-surface)",
    fillOpacity: 0.95
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2427 9.17192C16.6332 8.78139 16.6332 8.14824 16.2428 7.75775C15.8523 7.36726 15.2191 7.36729 14.8286 7.75782C13.9023 8.68413 12.976 9.61037 12.0497 10.5366C12.0331 10.5531 12.0166 10.5697 12.0001 10.5862C11.7993 10.3854 11.5985 10.1846 11.3977 9.98379C10.6557 9.24175 9.91364 8.49971 9.1716 7.75767C8.78107 7.36714 8.14793 7.36711 7.75744 7.7576C7.36694 8.14809 7.36698 8.78123 7.75751 9.17177C8.68381 10.0981 9.61006 11.0244 10.5363 11.9507C10.5528 11.9672 10.5694 11.9838 10.5859 12.0003C9.64302 12.9431 8.70017 13.8859 7.75736 14.8288C7.36684 15.2194 7.36692 15.8526 7.75743 16.2431C8.14794 16.6335 8.78113 16.6335 9.17164 16.243C10.1144 15.3001 11.0572 14.3573 12 13.4145C12.9428 14.3574 13.8856 15.3002 14.8285 16.243C15.2191 16.6335 15.8523 16.6334 16.2427 16.2429C16.6332 15.8524 16.6332 15.2192 16.2427 14.8287C15.2998 13.8859 14.357 12.9431 13.4142 12.0003C13.615 11.7996 13.8158 11.5988 14.0166 11.398C14.7586 10.656 15.5006 9.91396 16.2427 9.17192Z",
    fill: "var(--on-surface)",
    fillOpacity: 0.95
  })));
};
export default SvgActionClear;